import { createContext, useContext } from 'react';

export interface ChartRecommendation {
    chart_type: string;
    chart_title: string;
    x_axis: string;
    x_axis_label: string;
    y_axis: string;
    y_axis_label: string;
    y2_axis?: string | null;
    y2_axis_label?: string | null;
    color_column?: string | null;
    sort_x?: string;
    legend?: { show: boolean; position?: string | null; title?: string | null };
    reasoning?: string;
}

export interface Message {
    type: 'user' | 'genie';
    content: string;
    timestamp: string;
    suggestedQuestions?: string[];
    messageId?: string;
    attachmentId?: string;
    chartRecommendation?: ChartRecommendation;
}

export interface GenieContextType {
    messages: Message[];
    isThinking: boolean;
    thinkingStage: string | null;
    conversationId: string | null;
    sendMessage: (text: string) => Promise<void>;
    submitFeedback: (messageId: string, isUseful: boolean) => Promise<void>;
    getDownloadUrl: (messageId: string, attachmentId: string) => Promise<boolean>;
    restartConversation: () => Promise<void>;
}

export const GenieContext = createContext<GenieContextType | undefined>(undefined);

export const useGenie = () => {
    const context = useContext(GenieContext);
    if (context === undefined) {
        throw new Error('useGenie must be used within a GenieProvider');
    }
    return context;
};
